import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter, Route, Switch,Redirect} from "react-router-dom";
import './index.css';
import './iconfonts.css';
import App from './shared/containers/App/App';
import ElevatorBuild from './shared/containers/ElevatorBuild/index';
import Landing from './shared/containers/Landing/index';
import Login from './shared/containers/Login/index';
import { unregister } from './registerServiceWorker';
import {presets} from "./shared/stores";

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => (
        presets.gameCreate === true
            ? <Component {...props} />
            : <Redirect to='/' />
    )} />
)

const root = document.getElementById('root');
ReactDOM.render(
    <BrowserRouter>
        <Switch>
          <Route path="/" exact component={Landing} />
          <PrivateRoute path='/app' exact component={App} />
          {/*<Route path="/app" exact component={App} />*/}
          <Route path="/elevatorbuild" exact component={ElevatorBuild} />
          {/*<Route path="/login" exact component={Login}/>*/}
          {/*<Route path="/signup" exact component={SignUp}/>*/}
          {/*<Route path="/test" exact component={CompoundSlider}/>*/}
          <Route path="/settings" exact component={Login}/>
          <Redirect to={"/"}/>
        </Switch>
    </BrowserRouter>
    , root);
unregister();



// WEBPACK FOOTER //
// ./src/index.js